/**
 * An amount in Georgian words, the way the official waybill form writes it
 * in box 13: „120.0000 - ას ოცი ლარი და ნული თეთრი" (RS.GE print,
 * 2026-09-16). Georgian counts in twenties: 35 is „ოცდათხუთმეტი"
 * (twenty-and-fifteen), 99 „ოთხმოცდაცხრამეტი" (four-twenties-and-nineteen).
 */

const BASE = [
  'ნული', 'ერთი', 'ორი', 'სამი', 'ოთხი', 'ხუთი', 'ექვსი', 'შვიდი', 'რვა', 'ცხრა',
  'ათი', 'თერთმეტი', 'თორმეტი', 'ცამეტი', 'თოთხმეტი', 'თხუთმეტი', 'თექვსმეტი', 'ჩვიდმეტი', 'თვრამეტი', 'ცხრამეტი',
]
/** 20, 40, 60, 80 without their final „ი" — the form that takes „და". */
const SCORES = ['', 'ოც', 'ორმოც', 'სამოც', 'ოთხმოც']
/** 100…900 without the final „ი": „ას ოცი", but „ასი" alone. */
const HUNDREDS = ['', 'ას', 'ორას', 'სამას', 'ოთხას', 'ხუთას', 'ექვსას', 'შვიდას', 'რვაას', 'ცხრაას']

function under100(n: number): string {
  if (n < 20) return BASE[n]
  const score = Math.floor(n / 20)
  const rest = n % 20
  return rest === 0 ? `${SCORES[score]}ი` : `${SCORES[score]}და${BASE[rest]}`
}

function under1000(n: number): string {
  if (n < 100) return under100(n)
  const h = Math.floor(n / 100)
  const rest = n % 100
  return rest === 0 ? `${HUNDREDS[h]}ი` : `${HUNDREDS[h]} ${under100(rest)}`
}

/** A non-negative whole number in words (up to 999 999 999). */
export function numberWords(n: number): string {
  n = Math.floor(Math.abs(n))
  if (n < 1000) return under1000(n)
  if (n < 1_000_000) {
    const t = Math.floor(n / 1000)
    const rest = n % 1000
    const head = t === 1 ? 'ათას' : `${under1000(t)} ათას`
    return rest === 0 ? `${head}ი` : `${head} ${under1000(rest)}`
  }
  const m = Math.floor(n / 1_000_000)
  const rest = n % 1_000_000
  const head = `${under1000(m)} მილიონ`
  return rest === 0 ? `${head}ი` : `${head} ${numberWords(rest)}`
}

/** „120.0000 - ას ოცი ლარი და ნული თეთრი" — box 13 of the waybill form. */
export function lariInWords(amount: number): string {
  const tetriTotal = Math.round(Math.abs(amount) * 100)
  const lari = Math.floor(tetriTotal / 100)
  const tetri = tetriTotal % 100
  return `${numberWords(lari)} ლარი და ${numberWords(tetri)} თეთრი`
}
